import {NavLink as RouterLink} from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import {Box} from "@mui/material";

import {styles} from "./SidebarLink.styles";

interface SidebarLinkProps {
  disabled?: boolean;
  tooltipTitle: string;
  to: string;
  children: React.ReactElement;
}

export const SidebarLink: React.FC<SidebarLinkProps> = ({disabled, tooltipTitle, to, children}) => {
  return (
    <Tooltip title={disabled ? tooltipTitle : ""}>
      <Box width={"100%"}>
        <RouterLink
          to={disabled ? "#" : to}
          className={({isActive}) => `${styles.root} ${!disabled && isActive ? "link-active" : ""}`}
          end
        >
          {children}
        </RouterLink>
      </Box>
    </Tooltip>
  );
};
